"use strict";
// Boutique : ajout au panier sans rechargement, quantités, galerie produit, choix de variante.
(function () {
  const R = (window.LUXE && window.LUXE.routes) || { cart: "/cart", add: "/cart/add.js", cartJs: "/cart.js" };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  function majPanier() {
    fetch(R.cartJs, { headers: { Accept: "application/json" } }).then((r) => r.json()).then((c) => {
      document.querySelectorAll("[data-cart-count]").forEach((n) => { n.textContent = c.item_count; n.hidden = c.item_count === 0; });
    }).catch(() => {});
  }

  // Ajout au panier
  document.addEventListener("submit", (e) => {
    const f = e.target.closest("form[data-add-to-cart]");
    if (!f) return;
    e.preventDefault();
    const btn = $("[type=submit]", f), msg = $(".msg", f);
    btn.disabled = true;
    fetch(R.add, { method: "POST", headers: { Accept: "application/json" }, body: new FormData(f) })
      .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        msg.className = "msg" + (ok ? "" : " err");
        msg.textContent = ok ? "Ajouté au panier." : (j.description || j.message || "Impossible d'ajouter cet article.");
        // bouton « Aller au panier » à droite d'« Ajouter au panier »
        const go = $("[data-go-cart]", f);
        if (go && ok) { go.hidden = false; go.classList.remove("pop"); void go.offsetWidth; go.classList.add("pop"); }
        if (ok) majPanier();
      })
      .catch(() => { msg.className = "msg err"; msg.textContent = "Erreur réseau. Réessaie."; })
      .finally(() => { btn.disabled = false; });
  });

  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-qty]");
    if (b) {
      const i = $("input", b.parentElement), v = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      i.value = v; i.dispatchEvent(new Event("change", { bubbles: true }));
    }
    // panier : − / + (le − s'arrête à 1 ; pour supprimer il y a « Retirer »)
    const s = e.target.closest("[data-cart-step]");
    if (s) {
      const i = $("input", s.closest(".qty")), cur = parseInt(i.value, 10) || 1, v = Math.max(1, cur + parseInt(s.dataset.cartStep, 10));
      if (v !== cur) { i.value = v; s.closest(".qty").classList.add("maj"); i.closest("form").submit(); }
    }
    const t = e.target.closest("[data-thumb]");
    if (t) {
      const img = $("[data-main-img]");
      if (img) { img.srcset = ""; img.src = t.dataset.thumb; }
      document.querySelectorAll("[data-thumb]").forEach((x) => x.setAttribute("aria-current", x === t ? "true" : "false"));
    }
  });

  // Choix de variante : prix et disponibilité
  document.addEventListener("change", (e) => {
    const v = e.target.closest("[data-variant]");
    if (v) {
      const o = v.tagName === "SELECT" ? v.selectedOptions[0] : v, f = v.closest("form");
      const pr = $("[data-price]"); if (pr && o.dataset.price) pr.textContent = o.dataset.price;
      const pe = $("[data-prix-eur]"); if (pe && o.dataset.eurCents) { pe.dataset.eurCents = o.dataset.eurCents; if (window.LUXE_PRIX_EUR) window.LUXE_PRIX_EUR(); }
      const btn = $("[data-submit]", f), dispo = o.dataset.available === "true";
      btn.disabled = !dispo; btn.textContent = dispo ? "Ajouter au panier" : "Épuisé";
    }
    const q = e.target.closest("[data-cart-qty]");
    if (q) q.closest("form").submit();
  });

  // Menu mobile
  const nav = $("[data-nav]"), burger = $("[data-burger]");
  if (nav && burger) {
    const set = (open) => {
      nav.classList.toggle("open", open);
      document.documentElement.classList.toggle("menu-ouvert", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      burger.setAttribute("aria-label", open ? "Fermer le menu" : "Ouvrir le menu");
    };
    burger.addEventListener("click", () => set(!nav.classList.contains("open")));
    // un lien choisi, ou un appui sur la zone sombre à droite du panneau, referme le menu
    nav.addEventListener("click", (e) => { if (e.target.closest("nav a") || (e.target === nav && nav.classList.contains("open"))) set(false); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") set(false); });
    matchMedia("(min-width: 981px)").addEventListener("change", (m) => { if (m.matches) set(false); });
  }

  // Pages de politique : retire les restes d'un copier-coller de page web (code CSS visible, titre répété) et corrige une faute connue.
  (function nettoyerPolitique() {
    const corps = $(".shopify-policy__body .rte");
    if (!corps) return;
    const titrePage = $(".shopify-policy__title h1");
    const walker = document.createTreeWalker(corps, NodeFilter.SHOW_TEXT);
    const aRetirer = [];
    while (walker.nextNode()) {
      const n = walker.currentNode, t = n.textContent;
      if (n.parentElement.closest("a, li, h2, p, h1")) continue;
      if (/\{[^}]*(font-family|color|margin|padding)[^}]*\}/.test(t)) aRetirer.push(n);
      else if (/^\s*[^\n]{3,80}\s[—–-]\s[^\n]{1,30}\s*$/.test(t) && titrePage && t.toLowerCase().includes(titrePage.textContent.trim().toLowerCase())) aRetirer.push(n);
    }
    aRetirer.forEach((n) => n.remove());
    const h1 = $("h1", corps);
    if (h1 && titrePage && h1.textContent.trim() === titrePage.textContent.trim()) h1.remove();
    $$("h2", corps).forEach((h) => { h.textContent = h.textContent.replace(/Exercicer/g, "Exercer"); });
  })();
})();


// Sélecteur de thème (soleil dans la barre) : noir & or, ivoire, minuit.
(function () {
  const box = document.querySelector("[data-themer]");
  if (!box) return;
  const btn = box.querySelector("[data-themer-btn]"), menu = box.querySelector("[data-themer-menu]");
  const couleurs = { noir: "#060507", ivoire: "#F7F2E7", minuit: "#050816" };
  const appliquer = (nom) => {
    if (!couleurs[nom]) nom = "noir";
    if (nom === "noir") document.documentElement.removeAttribute("data-theme");
    else document.documentElement.setAttribute("data-theme", nom);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = couleurs[nom];
    menu.querySelectorAll("[data-set]").forEach((b) => b.setAttribute("aria-checked", b.dataset.set === nom));
  };
  const ouvrir = (oui) => { menu.classList.toggle("open", oui); btn.setAttribute("aria-expanded", oui); };
  let actuel = "noir";
  try { actuel = localStorage.getItem("luxe-theme") || "noir"; } catch (e) {}
  appliquer(actuel);
  btn.addEventListener("click", (e) => { e.stopPropagation(); ouvrir(!menu.classList.contains("open")); });
  menu.addEventListener("click", (e) => {
    const b = e.target.closest("[data-set]");
    if (!b) return;
    appliquer(b.dataset.set);
    try { localStorage.setItem("luxe-theme", b.dataset.set); } catch (err) {}
    ouvrir(false);
  });
  document.addEventListener("click", (e) => { if (!box.contains(e.target)) ouvrir(false); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") { ouvrir(false); btn.focus(); } });
})();

// Langue du site : traduction automatique Google Traduction, chargée seulement si le visiteur choisit une autre langue que le français
(function () {
  const box = document.querySelector("[data-langer]");
  if (!box) return;
  const btn = box.querySelector("[data-langer-btn]"), menu = box.querySelector("[data-langer-menu]");
  const lire = () => { const m = document.cookie.match(/(?:^|; )googtrans=\/fr\/([^;]+)/); return m ? decodeURIComponent(m[1]) : "fr"; };
  const poser = (code) => {
    const hote = location.hostname.replace(/^www\./, "");
    const domaines = ["", "; domain=" + hote, "; domain=." + hote];
    domaines.forEach((d) => { document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/" + d; });
    if (code !== "fr") domaines.forEach((d) => { document.cookie = "googtrans=/fr/" + code + "; path=/" + d; });
  };
  const actuelle = lire();
  box.querySelector("[data-langer-code]").textContent = (actuelle.split("-")[0] || "fr").toUpperCase();
  menu.querySelectorAll("[data-lang]").forEach((b) => b.setAttribute("aria-checked", b.dataset.lang === actuelle));
  btn.addEventListener("click", (e) => { e.stopPropagation(); const o = menu.classList.toggle("open"); btn.setAttribute("aria-expanded", o); });
  document.addEventListener("click", (e) => { if (!box.contains(e.target)) { menu.classList.remove("open"); btn.setAttribute("aria-expanded", "false"); } });
  menu.addEventListener("click", (e) => {
    const b = e.target.closest("[data-lang]");
    if (!b || b.dataset.lang === actuelle) return;
    poser(b.dataset.lang);
    // pays associé à la langue : Shopify affiche alors les prix dans la devise de ce pays (si elle est activée dans Marchés)
    const PAYS = { fr: "FR", de: "DE", es: "ES", it: "IT", nl: "NL", pt: "PT", en: "GB", pl: "PL", ar: "AE", ja: "JP", ko: "KR", "zh-CN": "CN", tr: "TR", af: "ZA", ru: "FR" };
    const f = document.createElement("form");
    f.method = "post"; f.action = "/localization"; f.style.display = "none";
    [["form_type", "localization"], ["utf8", "✓"], ["_method", "put"], ["country_code", PAYS[b.dataset.lang] || "FR"], ["return_to", location.pathname + location.search]]
      .forEach(([n, v]) => { const i = document.createElement("input"); i.type = "hidden"; i.name = n; i.value = v; f.appendChild(i); });
    document.body.appendChild(f); f.submit();
  });
  if (actuelle !== "fr" && window.LUXE_TRAD) {
    // 1. traductions faites à la main (luxe-traductions.js) : titres, accroches, boutons… avant Google
    const T = window.LUXE_TRAD, col = T.langues.indexOf(actuelle);
    if (col >= 0) {
      const norm = (s) => s.replace(/\s+/g, " ").trim();
      const dico = new Map(T.lignes.map((l) => [norm(l[0]), l[col + 1]]));
      const proteger = (el) => { el.classList.add("notranslate"); el.setAttribute("translate", "no"); };
      // titres en deux couleurs : « début|fin dorée »
      document.querySelectorAll("h1, h2, h3").forEach((h) => {
        const v = dico.get(norm(h.textContent));
        if (!v) return;
        const [a, b] = v.split("|"), g = h.querySelector(".grad, .gold, span");
        if (g && b !== undefined) {
          while (h.firstChild && h.firstChild !== g) h.removeChild(h.firstChild);
          while (g.nextSibling) h.removeChild(g.nextSibling);
          g.textContent = b;
          h.insertBefore(document.createTextNode(a + " "), g);
        } else h.textContent = v.replace("|", " ");
        proteger(h);
      });
      // textes simples (boutons, menus, étiquettes…)
      const w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, { acceptNode: (n) =>
        /SCRIPT|STYLE|TEXTAREA/.test(n.parentNode.nodeName) || !dico.has(norm(n.nodeValue)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT });
      const l = []; while (w.nextNode()) l.push(w.currentNode);
      l.forEach((n) => {
        const s = document.createElement("span"); proteger(s);
        const avant = n.nodeValue.match(/^\s*/)[0], apres = n.nodeValue.match(/\s*$/)[0];
        s.textContent = dico.get(norm(n.nodeValue));
        n.parentNode.insertBefore(document.createTextNode(avant), n);
        n.parentNode.insertBefore(s, n);
        n.parentNode.replaceChild(document.createTextNode(apres), n);
      });
      document.querySelectorAll("[placeholder]").forEach((i) => { const v = dico.get(norm(i.placeholder)); if (v) i.placeholder = v; });
    }
  }
  if (actuelle !== "fr") {
    // 2. le nom de la marque n'est jamais traduit : chaque « LuXe » / « Luxe » est marqué « ne pas traduire »
    const w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, { acceptNode: (n) =>
      /SCRIPT|STYLE|TEXTAREA/.test(n.parentNode.nodeName) || n.parentNode.closest(".notranslate") || !/lux(e|es)/i.test(n.nodeValue) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT });
    const noeuds = []; while (w.nextNode()) noeuds.push(w.currentNode);
    noeuds.forEach((n) => {
      const f = document.createDocumentFragment();
      n.nodeValue.split(/(LuXe for everyone|lux(?:e|es))/i).forEach((bout, i) => {
        if (i % 2) { const s = document.createElement("span"); s.className = "notranslate"; s.setAttribute("translate", "no"); s.textContent = bout; f.appendChild(s); }
        else if (bout) f.appendChild(document.createTextNode(bout));
      });
      n.parentNode.replaceChild(f, n);
    });
    window.luxeGT = function () { new google.translate.TranslateElement({ pageLanguage: "fr", autoDisplay: false }, "gt-cible"); };
    const s = document.createElement("script");
    s.src = "https://translate.google.com/translate_a/element.js?cb=luxeGT"; s.async = true;
    document.body.appendChild(s);
    document.documentElement.setAttribute("lang", actuelle);
  }
})();

// Téléphone : le choix du thème est aussi dans le menu des langues (un bouton de moins dans la barre)
(function () {
  const vrais = () => [...document.querySelectorAll("[data-themer-menu] [data-set]")];
  const synchro = () => {
    const actif = (vrais().find((b) => b.getAttribute("aria-checked") === "true") || {}).dataset;
    document.querySelectorAll("[data-set-proxy]").forEach((b) => b.setAttribute("aria-checked", !!actif && b.dataset.setProxy === actif.set));
  };
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-set-proxy]");
    if (!b) return;
    e.stopPropagation();
    const v = vrais().find((x) => x.dataset.set === b.dataset.setProxy);
    if (v) v.click();
    setTimeout(synchro, 50);
  });
  synchro();
})();

// Un seul menu ouvert à la fois (thème / langue) : celui qu'on ouvre passe devant, l'autre se ferme
(function () {
  const paires = [["[data-themer-btn]", "[data-langer-menu]", "[data-langer-btn]"], ["[data-langer-btn]", "[data-themer-menu]", "[data-themer-btn]"]];
  paires.forEach(([bouton, autreMenu, autreBouton]) => {
    const b = document.querySelector(bouton);
    if (b) b.addEventListener("click", () => {
      const m = document.querySelector(autreMenu), ab = document.querySelector(autreBouton);
      if (m) m.classList.remove("open"); if (ab) ab.setAttribute("aria-expanded", "false");
      document.querySelectorAll(".themer").forEach((t) => (t.style.zIndex = t.contains(b) ? 70 : ""));
    }, true);
  });
})();
